<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i"></a>Victory Girls, Khaki-Wackies, and Patriotutes <a id="page_ii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001_halftitle.vue?355e1479